import { request } from './client';
import type { ProductVatCheck, VatCheckLevel, VatMode, VatMonthReport, VatOffsetTask, VatOffsetTaskResult, VatRegimeItem, VatThreshold } from '@kassa/shared';

export interface VatAlerts {
  regimes: VatRegimeItem[];
  openTasks: number;
  unpriced: { count: number; qty: number };
  threshold: VatThreshold | null;
}

// ƏDV (KT-66): aylıq hesabat, mühasib tapşırıqları, xəbərdarlıqlar.
export const vatApi = {
  vatReport: (month: string) => request<VatMonthReport>('GET', `/api/vat/report?month=${encodeURIComponent(month)}`),
  vatTasks: () => request<VatOffsetTask[]>('GET', '/api/vat/tasks'),
  vatResolve: (id: string) => request<VatOffsetTaskResult>('POST', `/api/vat/tasks/${encodeURIComponent(id)}/resolve`),
  vatAlerts: () => request<VatAlerts>('GET', '/api/vat/alerts'),
  vatRegimes: () => request<VatRegimeItem[]>('GET', '/api/vat/regimes'),
  // KT-69: XİF MN üzrə ƏDV yoxlaması — siyahı (susmaya görə qırmızı, sarı, mavi) və «Seçimim düzdür»
  vatCheckList: (levels: VatCheckLevel[]) => request<ProductVatCheck[]>('GET', `/api/vat-check/products?level=${encodeURIComponent(levels.join(','))}`),
  vatCheckAck: (productId: string, reason: string | null, chosen?: VatMode) => request<ProductVatCheck>('POST', `/api/vat-check/products/${encodeURIComponent(productId)}/ack`, { reason, chosen: chosen ?? null }),
};
